import styles from "@/styles/productReviews.module.scss"
import { Image } from "antd"

interface PictureItem {
  thumbnailUrl: string;
  imageHDUrl: string;
  imageORUrl: string;
  fileNameUrl: string;
  isDefault: number;
}

interface Props {
  pictures: PictureItem[];
}
export default function ReviewImages({pictures}: Props) {
  return (
    <div className={styles['review-images']}>
      <Image.PreviewGroup>
        {
          pictures.map((item: PictureItem, index) => {
            return (
              <div className={styles['review-images-items']} key={index}>
                <Image
                  src={item.fileNameUrl}
                  alt={item.fileNameUrl}
                  width={'100%'}
                />
              </div>
            )
          })
        }
      </Image.PreviewGroup>
    </div>
  )
}